module.exports = __webpack_public_path__ + "static/media/ko1.98cf5fef.png";